export default __webpack_public_path__ + "static/media/germany_cropped.518d3099.png";